<template>
  <a-disclaimer
    :layout-ordering="disclaimerLayoutOrdering"
    :popup-settings-by-breakpoint="disclaimerPopupSettingsByBreakpoint"
    :top-space-offset="disclaimerTopSpaceOffset"
    :center-relative-to-activator="centerRelativeToActivator"
    show-beak
    class="general-risk-warning__wrapper"
  >
    <template v-slot:activator-content
      ><div class="general-risk-warning__disclaimer-icon-text-container">
        <a-icon
          :icon="$options.consts.ICON.WARNING_CIRCLE"
          :width="iconSize"
          :height="iconSize"
          class="general-risk-warning__disclaimer-icon"
        />
        <span class="general-risk-warning__disclaimer-label">
          General Risk Warning
        </span>
      </div></template
    >
    <template v-slot:content>
      <div class="general-risk-warning__disclaimer-text">
        {{ $options.consts.DISCLAIMER_TEXT }}
      </div>
    </template>
  </a-disclaimer>
</template>

<script>
import AIcon, { ICON } from '@/components/_shared/AIcon/index.vue'
import { PROP_TYPES, propValidator } from '@fmpedia/validators'
import ADisclaimer from '@/components/_shared/ADisclaimer/index.vue'

const DISCLAIMER_TEXT =
  'investingLive is a market news and analysis platform that lists and reviews forex brokers for informational use only. We do not provide investment advice or brokerage services. CFDs are complex, high-risk products and may not be suitable for all investors. investingLive is not responsible for any trading losses or decisions made based on content found on our site.'

const DEFAULT_ICON_SIZE = 12

export default {
  name: 'AGeneralRiskWarning',
  components: { ADisclaimer, AIcon },
  props: {
    disclaimerLayoutOrdering: propValidator(
      [PROP_TYPES.ARRAY],
      false,
      undefined
    ),
    disclaimerPopupSettingsByBreakpoint: propValidator(
      [PROP_TYPES.OBJECT],
      false,
      undefined
    ),
    disclaimerTopSpaceOffset: propValidator(
      [PROP_TYPES.NUMBER],
      false,
      undefined
    ),
    centerRelativeToActivator: propValidator(
      [PROP_TYPES.BOOLEAN],
      false,
      false
    ),
    iconSize: propValidator([PROP_TYPES.NUMBER], false, DEFAULT_ICON_SIZE)
  },
  consts: {
    DISCLAIMER_TEXT,
    ICON
  }
}
</script>

<style lang="scss" scoped>
.general-risk-warning__wrapper {
  .general-risk-warning__disclaimer-icon-text-container {
    display: flex;
    align-items: center;

    &:hover {
      .general-risk-warning__disclaimer-label,
      .general-risk-warning__disclaimer-icon {
        color: $c--mid-purple;
        fill: $c--mid-purple;
      }
    }
  }

  .general-risk-warning__disclaimer-icon {
    fill: $c--gray;
  }

  .general-risk-warning__disclaimer-label {
    margin-left: 2px;
    font-size: 12px;
    color: $c--gray;
  }

  .general-risk-warning__disclaimer-text {
    font-size: 12px;
    font-weight: 500;
    line-height: 16px;
    letter-spacing: -0.15px;
    color: $c--gray-dark-2;
  }

  /deep/ .disclaimer-popup__wrapper {
    border: 2px solid $c--main;
    padding: 12px 16px;
    border-radius: 4px;
    background: $c--gray-soft;
  }

  /deep/ .disclaimer-popup__icon {
    display: none;
  }
}
</style>
